import type { Region } from './regionsApi';

export const REGION_NAME_MAX = 100;
export const REGIONS_PER_PAGE = 50;

/** Название без лишних пробелов: так его сохраняет и сервер */
export function normalizeName(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}

/** Проверка названия до отправки; сервер повторяет ее. Пустая строка - ошибок нет */
export function validateRegionName(value: string, regions: Region[], exceptId: number | null): string {
  const name = normalizeName(value);
  if (!name) return 'Укажите название региона';
  if (name.length > REGION_NAME_MAX) return `Название не длиннее ${REGION_NAME_MAX} символов`;

  const lower = name.toLowerCase();
  const taken = regions.some((item) => item.id !== exceptId && item.name.toLowerCase() === lower);
  return taken ? 'Регион с таким названием уже существует' : '';
}

export function filterRegions(regions: Region[], query: string): Region[] {
  const needle = query.trim().toLowerCase();
  if (needle === '') return regions;
  return regions.filter((item) => item.name.toLowerCase().indexOf(needle) >= 0);
}

export function pageCount(total: number): number {
  return Math.max(1, Math.ceil(total / REGIONS_PER_PAGE));
}

export function pageSlice(regions: Region[], page: number): Region[] {
  return regions.slice((page - 1) * REGIONS_PER_PAGE, page * REGIONS_PER_PAGE);
}

/** К региону привязаны сотрудники или терминалы: его нельзя удалить, а переименование их затронет */
export function isRegionUsed(region: Region): boolean {
  return region.usersCount > 0 || region.terminalsCount > 0;
}

/** Текст о привязке: «сотрудников: 3, терминалов: 1» (пусто, если привязок нет) */
export function usageText(region: Pick<Region, 'usersCount' | 'terminalsCount'>): string {
  const parts: string[] = [];
  if (region.usersCount > 0) parts.push(`сотрудников: ${region.usersCount}`);
  if (region.terminalsCount > 0) parts.push(`терминалов: ${region.terminalsCount}`);
  return parts.join(', ');
}

/** Дата для таблицы; пустая строка, если даты нет или она не разобралась */
export function formatDate(value: string | null): string {
  if (!value) return '';
  const date = new Date(value);
  return isNaN(date.getTime()) ? '' : date.toLocaleDateString('ru-RU');
}
